<template>
<el-scrollbar :ref="scrollRef">
  <el-tree class="tree-w-stroke obj-tree" :ref="treeRef" :data="treeData" :props="defaultProps" :node-key="defaultProps.treeKey" :expand-on-click-node="false" highlight-current @node-click="clickNode" :filter-node-method="filterNode">
    <span class="el-tree-node__label" slot-scope="{ node, data }">
      <!-- obj -->
      <el-tooltip v-if="isObjNode(data) && isRequireIPObjType(data)" class="item" effect="dark" :content="getIpTooltipContent(data)" placement="right">
        <span>
          <span v-if="!isEmpty(data.subType)" class="obj-icon">
            <i :class="getObjTypeIconClass(data)"></i>
          </span>
          <span :style="getNodeEventLevelStyle(data)"></span>
          <span>{{data.label}}</span>
        </span>
      </el-tooltip>
      <span v-else-if="isObjNode(data)">
        <span v-if="!isEmpty(data.subType)" class="obj-icon">
          <i :class="getObjTypeIconClass(data)"></i>
        </span>
        <span :style="getNodeEventLevelStyle(data)"></span>
        <span>{{data.label}}</span>
      </span>
      <!-- root, group -->
      <span v-else>
        <span :style="getNodeEventLevelStyle(data)"></span>
        <span class="group">{{data.label}}</span>
      </span>
    </span>
  </el-tree>
</el-scrollbar>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import RouterTree from '@/mixins/router/tree';
import TreeFilter from '@/mixins/tree/filter';
import { defaultProps, treeType } from '@/constants/tree';
import { isRequireIPObjType, getObjTypeIconClass, isObjNode, getIpTooltipContent, hasObjTypeIcon } from '@/utils/tree';
import { getValueAfterCheckEmpty } from '@/utils/string';
import eventStatusMixin from './mixins/event-status';

export default {
  name: 'WPhysicalStaticTree',
  mixins: [RouterTree, TreeFilter, eventStatusMixin],
  props: {
    treeTypes: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      treeType: treeType.PHYSICAL,
      treeRef: `${treeType.PHYSICAL}Tree`,
      treeTypesInMenu: this.treeTypes,
      defaultProps,
      first: false,
    };
  },
  computed: {
    physicalTreeData() {
      return this.$store.state.tree.physicalTreeData;
    },
  },
  watch: {
    physicalTreeData: {
      immediate: true,
      handler(to) {
        this.treeData = to;
        if (!isEmpty(to)) {
          this.$nextTick(() => {
            const root = this.$refs[this.treeRef].root;
            root.childNodes[0].expanded = true;
            this.setEventStatusToNodeDatas(to);
          });
        }
      },
    },
  },
  methods: {
    isEmpty,
    getValueAfterCheckEmpty,
    isObjNode,
    isRequireIPObjType,
    hasObjTypeIcon,
    getObjTypeIconClass,
    getIpTooltipContent,
    /**
     * 노드 클릭 이벤트 핸들러
     * @author Ju
     * @param  {[type]} nodeData [description]
     * @return {[type]}          [description]
     */
    clickNode(nodeData) {
      this.routeByTreeKey(this.concatTreeTypeAndTreeKey(nodeData[this.defaultProps.treeKey]));
    },
    getNodeEventLevelStyle(data) {
      if (!isNil(data.eventlevelId) && data.eventlevelId !== '') {
        const eventlevel = this.eventlevelInfo[data.eventlevelId];
        if (!isEmpty(eventlevel)) {
          return {
            content: ' ',
            display: 'inline-block',
            width: '4px',
            height: '4px',
            'border-radius': '50%',
            'background-color': eventlevel.eventlevelColorBg,
            position: 'relative',
            top: '-3px',
          };
        }
      }
      return null;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/tree/TargetTree/PhysicalTree.vue